/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';
import { LuBuilding2, LuUsers } from 'react-icons/lu';

import { useHistory } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';

import api from '../../../../services/api';

import { useToast } from '../../../../hooks/toast';

import {
  Field,
  FilterStyles,
  Section,
} from '../../../../components/FilterKit';

interface SearchData {
  proc_cod_cliente: number;
  proc_em_acordo: string;
}

const SearchLawsuitSummaryExcel:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  sessionStorage;

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    proc_em_acordo: '0',

  };

  const [customerId, setCustomerId] = useState('0');
  const [lawsuitStatus, setLawsuitStatus] = useState('0');
  const [customersOptions, setCustomersOptions] = useState([{}]);

  const handleClear = (handleReset: () => void) => {
    setCustomerId('0');
    setLawsuitStatus('0');
    handleReset();
  };

  const validationSchema = null;

  const lawsuitStatusOptions = [
    { name: 'ativos', value: '0', style: 'font-size: small;' },
    { name: 'arquivados', value: '2', style: 'font-size: small;' },
    { name: 'todos', value: '5', style: 'font-size: small;' },
  ];

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      const searchFormData = {
        proc_cod_cliente: customerId,
        proc_em_acordo: lawsuitStatus,
      };

      history.push({
        pathname: '/report/lawsuit/simplified/excel',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          isSubmitting,
          handleSubmit,
          handleReset,
        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>Relatório Resumido de Informações Processuais - Filtro Excel</h3>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuUsers />} title="Cliente">
                  <Field id="proc_cliente" label="Cliente">
                    <Dropdown
                      id="proc_cliente"
                      name="proc_cliente"
                      options={customersOptions}
                      onChange={(e) => setCustomerId(e.target.value)}
                      value={customerId}
                      className="inputfield w-full"
                      optionLabel="name"
                      optionValue="value"
                      filter
                      resetFilterOnHide
                      filterBy="name"
                      placeholder="Selecione uma opção"
                      emptyFilterMessage="Nenhum registro encontrado"
                    />
                  </Field>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuBuilding2 />} title="Situação do processo">
                  <Field id="proc_em_acordo" label="Incluir processos">
                    <SelectButton
                      id="proc_em_acordo"
                      value={lawsuitStatus}
                      options={lawsuitStatusOptions}
                      optionLabel="name"
                      onChange={(e) => setLawsuitStatus(e.value)}
                    />
                  </Field>
                </Section>
              </div>
            </div>

            <footer className="search-actions">
              <div className="buttons">
                <Button
                  icon="pi pi-undo"
                  iconPos="left"
                  label="Limpar campos"
                  className="p-button-outlined p-button-secondary"
                  type="button"
                  onClick={() => handleClear(handleReset)}
                />
                <Button
                  icon="pi pi-check"
                  iconPos="left"
                  label="Pesquisar processos"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </footer>
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchLawsuitSummaryExcel;
